import React, { useContext, useEffect, useState } from "react";
import { MemoContext } from "../../contexts/MemoContext";
import EmptyMemo from "../../components/EmptyMemo";
import { useParams, useHistory } from "react-router-dom";
import MemoItem from "../../components/MemoItem";
import Masonry from "react-masonry-css";
import axios from "axios";
import { Spin } from "antd";

const SearchIndex = () => {
  const [status, setStatus] = useState("load");
  const { memoData } = useContext(MemoContext);
  const { search } = useParams();
  const [sMid, setSMid] = useState([]);
  const [fSearch, setFSearch] = useState([]);
  const history = useHistory();
  useEffect(() => {
    setFSearch([search]);
  }, [search]);
  useEffect(() => {
    setStatus("load");
    axios
      .get("https://api.aiforthai.in.th/thaiwordsim", {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Apikey: "bXagwMODVlCkp1fxJm7jyZjwy22D81G5",
        },
        params: {
          word: search,
          numword: 10,
          model: "thwiki",
        },
      })
      .then((res) => {
        let finalSearch = [search];
        let words = res.data.words;
        words = words.map((e) => {
          return e.word;
        });
        if (words.length > 0) {
          finalSearch = [...finalSearch, ...words];
        }
        setFSearch(finalSearch);
        axios
          .post("/search", { finalSearch })
          .then((sRes) => {
            setSMid(sRes.data.map((e) => e.mid));
            if (sRes.data.length > 0) {
              setTimeout(() => {
                setStatus("found");
              }, 300);
            } else setStatus("x");
          })
          .catch((e1) => {
            console.log(e1);
          });
      })
      .catch((e2) => {
        console.log(e2);
      });
  }, [search]);
  useEffect(() => {}, [sMid]);
  return (
    <div className="w-full h-full overflow-scroll p-5">
      <div className="flex w-full justify-between px-1 items-center mb-4">
        <div className="text-xl text-gray-500 flex items-center">
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
            />
          </svg>
          <p className="p-0 m-0 ml-3">
            {fSearch.map((e, i) => {
              if (i < 5) {
                return <span key={i}>{e} </span>;
              } else return null;
            })}
          </p>
        </div>
        <div
          className="text-xl text-gray-500 flex items-center cursor-pointer"
          onClick={() => history.push("/")}
        >
          <svg
            className="w-6 h-6"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              d="M7.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l2.293 2.293a1 1 0 010 1.414z"
              clipRule="evenodd"
            />
          </svg>
          <p className="p-0 m-0 ml-3">Back</p>
        </div>
      </div>
      {status === "found" ? (
        <Masonry
          breakpointCols={4}
          className="my-masonry-grid"
          columnClassName="my-masonry-grid_column"
        >
          {memoData
            .filter((e) => {
              return sMid.indexOf(e.mid) > -1;
            })
            .map((e) => {
              return (
                <MemoItem
                  key={e.mid}
                  mid={e.mid}
                  content={e.memo_content}
                  tags={e.tags}
                  created={e.created}
                  fav={e.fav}
                  updated={e.updated}
                />
              );
            })}
        </Masonry>
      ) : (
        <div className="h-full w-full flex justify-center items-center">
          {status === "load" ? <Spin size="large" /> : <EmptyMemo />}
        </div>
      )}
    </div>
  );
};

export default SearchIndex;
